
export default {
  data() {
    return {
      title: "BikeflightsFor Business | Bikeflights.com",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
};
